import { getLocalizedPath } from '../i18n/localizedRoutes';

export const ziruiProfile = {
  path: '/team/zirui-qiu',
  website: 'https://ziruiqiu.com/',
  image: '/images/Destiny - Zirui Qiu Signature Yo-Yo/Thank you for supporting Zirui Qiu.jpg',
  destinyPath: '/store/destiny-zirui-qiu-signature-yo-yo',
  socials: [
    { name: 'GitHub', url: 'https://github.com/Pocket99' },
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/zirui-qiu-52920b199/' },
    { name: 'Instagram', url: 'https://www.instagram.com/pocket_qiu/' },
  ],
};

export const getZiruiProfileSchemas = (t, locale, siteUrl) => {
  const url = `${siteUrl}${getLocalizedPath(ziruiProfile.path, locale)}`;
  const personId = `${siteUrl}${ziruiProfile.path}#person`;
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'ProfilePage',
      '@id': `${url}#profile`,
      url,
      name: t('profile.seoTitle'),
      description: t('profile.seoDescription'),
      inLanguage: locale,
      mainEntity: {
        '@type': 'Person',
        '@id': personId,
        name: 'Zirui Qiu',
        alternateName: ['仇子睿', 'Pocket'],
        url: ziruiProfile.website,
        image: `${siteUrl}${encodeURI(ziruiProfile.image)}`,
        description: t('profile.intro'),
        jobTitle: t('profile.jobTitle'),
        knowsAbout: ['React', 'Flask', 'AI', '1A', '2A'],
        affiliation: { '@type': 'Organization', name: 'YCH-YOYO', url: siteUrl },
        sameAs: [ziruiProfile.website, ...ziruiProfile.socials.map(({ url: socialUrl }) => socialUrl)],
        award: [t('profile.yoyo.twoA'), t('profile.yoyo.regional'), t('profile.yoyo.national')],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: t('profile.breadcrumb.home'), item: `${siteUrl}${getLocalizedPath('/', locale)}` },
        { '@type': 'ListItem', position: 2, name: t('profile.breadcrumb.team'), item: `${siteUrl}${getLocalizedPath('/team', locale)}` },
        { '@type': 'ListItem', position: 3, name: t('profile.name'), item: url },
      ],
    },
  ];
};
